import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ebcaaf7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "nav-buttons" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-share" }, null, -1))
const _hoisted_6 = ["href", "download"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-download" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-info" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-label-add" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-edit" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-dots" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-share'))),
        class: _normalizeClass(["nav-btn", { disabled: !_ctx.toShare }])
      }, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.$localize('photo.view.share')), 1)
      ], 2),
      _createElementVNode("a", {
        href: _ctx.downloadUrl,
        download: _ctx.file.name,
        class: "nav-btn__download-link nav-btn"
      }, [
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(_ctx.$localize('media.settings.popup.download')), 1)
      ], 8, _hoisted_6),
      _createElementVNode("div", {
        class: "nav-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('on-info')))
      }, [
        _hoisted_8,
        _createTextVNode(" " + _toDisplayString(_ctx.$localize('photo.view.info')), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["nav-btn", { disabled: _ctx.isNetwork || !_ctx.isMy }]),
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('on-labels')), ["prevent"]))
      }, [
        _hoisted_9,
        _createTextVNode(" " + _toDisplayString(_ctx.$localize('photo.view.labels')), 1)
      ], 2),
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('on-edit')), ["prevent"])),
        class: _normalizeClass([{ disabled: !_ctx.showEdit || !_ctx.isMy }, "nav-btn"])
      }, [
        _hoisted_10,
        _createTextVNode(" " + _toDisplayString(_ctx.$localize('photo.view.edit')), 1)
      ], 2),
      _createElementVNode("div", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('on-view-more'))),
        class: _normalizeClass(["nav-btn", { disabled: _ctx.isPublicCase }])
      }, [
        _hoisted_11,
        _createTextVNode(" " + _toDisplayString(_ctx.$localize('photo.view.more')), 1)
      ], 2)
    ])
  ]))
}